// The ROUTE POSTURE a client renders its affordances from — what @platform/http's
// authz gate reads (`RouteAuthz`: roles, allowPending, topLevel, tos) as the
// OpenAPI document carries it (`x-required-roles`, `x-allows-pending`,
// `x-requires-top-level-firm`, `x-requires-tos`), generated back into a
// TYPED catalog per owner by scripts/gen-wire.ts (§route-posture). The SPA's
// table spine derives its create / edit / delete affordances through `admits`
// below, so a page never restates a route's list by hand, and a control the
// server would refuse is never offered.
//
// Roles and module keys are plain STRINGS here, never `RoleKey` / `ModuleKey`:
// the generated core catalog is written from the full tree and typechecked in
// every client shape (a pruned tree lacks the union members the full tree
// listed), and the caller's role is a session claim, which is how `hasRole`
// treats it too.
// The two MINTS (the mintRoleList mold): the literal keys survive (`const T`),
// so a catalog member a page names is a compile error the day the document
// stops carrying it, and a posture written by hand is one today.
function branded(specs) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- the brand's one mint; the callers are the generated catalogs, whose members the drift gate holds to the document
    return specs;
}
export function operationPostures(ops) {
    return branded(ops);
}
export function resourcePostures(res) {
    return branded(res);
}
const exemptFrom = (spec, role) => spec !== true && spec.exempt.includes(role);
/**
 * Does the gate admit this caller? The client half of `authzGate`
 * (packages/http/src/route/authz.ts), arm for arm: membership, then the
 * status switch unless the operation admits a pending account, then consent
 * and the tenant-root pin unless the role is exempt. A `session` operation has
 * no gate beyond the session.
 */
export function admitsGate(gate, caller) {
    if (gate.roles === 'public')
        return true;
    const { role } = caller;
    if (role === null)
        return false;
    // The session hook refuses EVERY request from a suspended account (401
    // account_suspended) before any route gate reads its roles, so no operation
    // admits one — not a `session` route, which carries no gate of its own, and
    // not an `allowsPending` route, whose gate runs the membership half alone.
    if (caller.status === 'suspended')
        return false;
    if (gate.roles === 'session')
        return true;
    if (!gate.roles.includes(role))
        return false;
    if (gate.allowsPending !== true && caller.status !== 'active')
        return false;
    if (gate.tos !== undefined) {
        const spec = typeof gate.tos === 'string' ? { module: gate.tos, exempt: [] } : gate.tos;
        if (!spec.exempt.includes(role) && !caller.tos.includes(spec.module))
            return false;
    }
    if (gate.topLevel !== undefined && !exemptFrom(gate.topLevel, role) && !caller.firmTopLevel) {
        return false;
    }
    return true;
}
/** `admitsGate` over an operation's posture; no operation, no affordance. */
export function admits(op, caller) {
    return op === undefined ? false : admitsGate(op, caller);
}
//# sourceMappingURL=route-posture.js.map